import React, { useEffect, useState, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  Checkbox,
  Input,
  RadioButton,
  RadioButtonChangeEvent,
  TextArea,
} from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { State } from "@progress/kendo-data-query";
import "../css/Duration.scss";
import "../css/Common.scss";
import Breadcrumbs from "../components/Breadcrumbs";
import axios from "axios";
import { chevronDownIcon } from "@progress/kendo-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Error } from "@progress/kendo-react-labels";
import { MyDatePicker } from "./MyDatePicker";
import { Loader } from "@progress/kendo-react-indicators";
import { commonBaseUrl } from "../../services/CommonUtil";

interface Spac {
  Id: number;
  SpaceType: string;
  checked: boolean;
  SpaceDetails: DurationDetail[];
}

interface DurationData {
  DurationId: number;
  DurationName: string;
  RentAmount: number;
  DiscountValue?: number;
  DiscountPrice?: number;
}

type DurationDetail = {
  durationId: number;
  durationName: string;
  actualPrice: number;
  discountValue: number;
  discountPrice: number;
};

type Space = {
  id: number;
  spaceName: string;
  durationDetails: DurationDetail[];
};

export const EditDiscount = () => {
  const baseURL = commonBaseUrl();
  const location = useLocation();
  const DataItem = location?.state.ItemInfo || {};
  const navigate = useNavigate();

  useEffect(() => {}, [DataItem]);

  const breadCrumbsData = [
    {
      id: "1",
      text: "Masters",
      route: "",
    },
    {
      id: "2",
      text: "Discount",
      route: "/masters/discount",
    },
    {
      id: "3",
      text: "Edit discount",
      route: "",
    },
  ];

  //mani sir code

  const [selectedSpaces, setSelectedSpaces] = useState<string[]>([]);
  const [discountTypeList, discountTypeListSet] = useState<any>();
  const [spaceList, spaceListSet] = useState<Spac[]>([]);
  const [firsttime, setFirstTime] = useState(true);
  const [allDiscountData, setAllDiscountData] = useState<any>(
    DataItem.discountDetails
  );

  useEffect(() => {
    const SpacesApi = async () => {
      try {
        const response = await axios.get(
          `${baseURL}odata/SpaceHeaders?$filter=IsActive eq true&$expand=SpaceDetails($filter=IsActive eq true;$expand=Duration($select=DurationType))`
        );
        const ss = response.data.value;
        const dats = ss.map((dataItem: any, index: number) => {
          console.log("Space Index -->", index);
          return {
            Index: index,
            Id: dataItem.Id,
            checked: false,
            SpaceType: dataItem.SpaceName,
            SpaceDetails: dataItem.SpaceDetails,
          };
        });
        console.log("Space Api List -->", dats);
        spaceListSet(dats);
        updatedSpaceList = dats.map((space: any) => {
          const found = spaceNames.find(
            (r: any) => r.SpaceType === space.SpaceType
          );
          if (found) {
            return { ...space, checked: true };
          }
          return space;
        });
        console.log(
          "updated space list from the api calculation -->",
          updatedSpaceList
        );
        spaceListSet(updatedSpaceList);
        setSelectedSpaces(updatedSpaceList);
      } catch (err) {}
    };
    const discountTypeApi = async () => {
      try {
        const response = await axios.get(`${baseURL}odata/GetAllDiscountType`);
        discountTypeListSet(response.data);
        selectedTypeSet(response.data[1]);
      } catch (err) {}
    };
    if (firsttime === true) {
      SpacesApi();
      discountTypeApi();
      setFirstTime(false);
    }
  });

  const spaceNames = DataItem.discountDetails.map((space: any) => ({
    Id: space.durationDetails[0].applicableSpacesId,
    SpaceType: space.spaceName,
    checked: true,
  }));

  // Update checked values in the spaceList based on the result list
  var updatedSpaceList;
  const storeDiscountData: any[] = [];

  const customStyles = `
    .no-wheel input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      /* Hide spinner controls */
      pointer-events: none;
      user-select: none;
    }
    
    .no-wheel input::-webkit-inner-spin-button,
    .no-wheel input::-webkit-calendar-picker-indicator {
      display: none;
    }
    
    .no-wheel input::-moz-inner-spin-button {
      display: none;
    }
    `;
  const timePickerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = timePickerRef.current;
    const handleWheel = (event: WheelEvent) => {
      event.preventDefault();
    };
    if (element) {
      element.addEventListener("wheel", handleWheel, { passive: false });
      return () => {
        element.removeEventListener("wheel", handleWheel);
      };
    }
  }, []);

  const setTimeCalc = (value: any, name: string) => {
    if (name === "end") {
      endDateSet(value);
    } else {
      startDateSet(value);
      if (value > endDate! && endDate !== undefined) {
        endDateSet(value);
      }
    }
  };

  const durationSpaceApi = async (data: any, selectedSpaceType: string) => {
    const durationList = data;
    const transformedData = transformResponse(durationList, selectedSpaceType);
    if (allDiscountData !== undefined) {
      for (let d = 0; d < allDiscountData.length; d++) {
        storeDiscountData.push(allDiscountData[d]);
      }
    }
    storeDiscountData.push(transformedData);
    setAllDiscountData(storeDiscountData);
  };

  const transformResponse = (response: any, selectedSpaceType: string) => {
    return {
      spaceName: selectedSpaceType,
      durationDetails: response.map((detail: any) => ({
        applicableSpacesId: detail.SpaceHeaderId,
        durationId: detail.DurationId,
        durationName: detail.Duration.DurationType,
        actualPrice: detail.RentAmount,
        discountValue: 0, // Default value
        discountPrice: 0, // Default value
      })),
    };
  };

  const [selectedValue, setSelectedValue] = useState(`${DataItem.eligibleFor}`);

  const handleCheckboxChange = (item: any, index: any) => {
    selectedSpaceTypesSet("");
    const updatedList = [...spaceList];
    updatedList[index].checked = !updatedList[index].checked;
    spaceListSet(updatedList);
    const selectedSpaceTypes = updatedList[index].SpaceType;
    selectedSpaceTypesSet(selectedSpaceTypes);
    if (updatedList[index].checked) {
      setAllDiscountData(updatedList[index].SpaceDetails);
      setSelectedSpaces([...selectedSpaces, selectedSpaceTypes]);
      durationSpaceApi(item.SpaceDetails, item.SpaceType);
    } else {
      setSelectedSpaces(
        selectedSpaces.filter((space) => space !== selectedSpaceTypes)
      );
      setAllDiscountData(
        allDiscountData.filter(
          (space: any) => space.spaceName !== selectedSpaceTypes
        )
      );
    }
  };

  //Handle mani code
  const handleDiscountChange = (
    spaceId: string,
    durationId: number,
    field: keyof DurationDetail,
    value: number
  ) => {
    setAllDiscountData((prevSpaces: any) =>
      prevSpaces.map((space: Space) => {
        if (space.spaceName === spaceId) {
          return {
            ...space,
            durationDetails: space.durationDetails.map(
              (detail: DurationDetail) => {
                if (detail.durationId === durationId) {
                  const updatedDetail = detail;
                  if (value <= 100) {
                    updatedDetail.discountValue = value;
                  }
                  if (selectType.id === 2) {
                    const discountAmount =
                      (updatedDetail.discountValue *
                        updatedDetail.actualPrice) /
                      100;
                    updatedDetail.discountPrice =
                      updatedDetail.actualPrice - discountAmount >= 0
                        ? updatedDetail.actualPrice - discountAmount
                        : 0;
                  } else {
                    updatedDetail.discountPrice =
                      updatedDetail.actualPrice - updatedDetail.discountValue >=
                      0
                        ? updatedDetail.actualPrice -
                          updatedDetail.discountValue
                        : 0;
                  }
                  // }
                  return updatedDetail;
                }
                return detail;
              }
            ),
          };
        }
        return space;
      })
    );
  };

  let header = {
    "Content-Type":
      "application/json;odata.metadata=minimal;odata.streaming=true",
    accept: "*/*",
  };

  const [edited, editedSet] = useState(true);
  const [startDate, startDateSet] = useState(new Date(DataItem.startDate));
  const [endDate, endDateSet] = useState(new Date(DataItem.endDate));
  const [selectedUsage, selectedUsageSet] = useState(
    `${DataItem.usageLimit === 0 ? "" : DataItem.usageLimit}`
  );

  const convertToISOFormat = (inputDate: any): string => {
    // Parse the input date string to a Date object
    const dateObj = new Date(inputDate);

    // Extract the individual date components
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
    const day = String(dateObj.getDate()).padStart(2, "0");

    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    // Get the timezone offset in hours and minutes
    const timezoneOffset = -dateObj.getTimezoneOffset(); // In minutes
    const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(
      2,
      "0"
    );
    const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(
      2,
      "0"
    );

    // Construct the ISO 8601 formatted string with timezone
    const isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+${offsetHours}:${offsetMinutes}`;

    return isoFormattedDate;
  };

  const [statusDialog, statusDialogSet] = useState(false);
  const [alertState, alertStateSet] = useState(false);
  const [alert, alertSet] = useState("");
  const [error, setError] = useState(false);

  const updateDiscount = () => {
    checkSet(true);
    if (discountName.trim() === "") {
      nameErrorSet("Discount name / Coupon code must be provided");
    } else {
      console.log("name", true);
      nameErrorSet("");
    }
    if (discountDescription.trim() === "") {
      descriptionErrorSet("Description must be provided");
    } else {
      console.log("desc", true);
      descriptionErrorSet("");
    }
    if (selectType.id === null) {
      typeErrorSet("Select the type");
    } else {
      console.log("type", true);
      typeErrorSet("");
    }
    if (startDate === undefined) {
      startErrorSet("Choose the Start Date ");
    } else {
      console.log("start", true);
      startErrorSet("");
    }
    if (endDate === undefined) {
      endErrorSet("Choose the End Date");
    } else {
      console.log("end", true);
      endErrorSet("");
    }
    if (isChecked === false) {
      if (selectedUsage === "") {
        limitErrorSet("Enter the Usage limit");
      } else if (parseInt(selectedUsage) <= 0) {
        limitErrorSet("Enter the Usage limit");
      } else {
        limitErrorSet("");
      }
    }
    if (selectedSpaces.length === 0) {
      spaceErrorSet("Select the Spaces");
      console.log(
        "Error handling",
        selectedSpaceTypes,
        selectedSpaceTypes === ""
      );
    } else {
      console.log("Space --< length -->", selectedSpaces.length);
      spaceErrorSet("");
    }
    let Validate = true;
    Validate = allDiscountData.every((item: any) =>
      item.durationDetails.some(
        (durationItem: any) => durationItem.discountValue !== 0
      )
    );
    if (Validate) {
      setError(false);
    } else {
      setError(true);
    }

    if (
      discountName.trim() !== "" &&
      discountDescription.trim() !== "" &&
      selectType.id !== null &&
      startDate !== undefined &&
      endDate !== undefined &&
      allDiscountData.length !== 0
      // && selectedUsage !== ""
      // parseInt(selectedUsage) > 0 &&
    ) {
      if (
        isChecked === false &&
        selectedUsage !== "" &&
        parseInt(selectedUsage) > 0
      ) {
        if (Validate === true) {
          updateApi();
        }
      } else if (isChecked === true) {
        if (Validate === true) {
          updateApi();
        }
      }
    }
  };

  const updateApi = async () => {
    setLoading(true);
    const updateDiscount = {
      id: DataItem.id,
      discountName: discountName,
      description: discountDescription,
      discountType: selectType.id,
      startDate: convertToISOFormat(startDate),
      endDate: convertToISOFormat(endDate),
      eligibleFor: parseInt(selectedValue),
      usageLimit: selectedUsage,
      IsInstantDiscount: isChecked,
      discountDetails: allDiscountData,
    };

    try {
      const response = await axios.post(
        `${baseURL}odata/UpdateDiscountHeader`,
        updateDiscount,
        {
          headers: header,
        }
      );
      alertStateSet(false);
      statusDialogSet(true);
      setLoading(false);
      alertSet("Discount updated successfully");
    } catch (err: any) {
      console.log(err);
      alertStateSet(true);
      setLoading(false);
      statusDialogSet(true);
      alertSet(err.response.data.detail);
    }
  };

  const navigateBack = () => {
    if (alertState === false) {
      navigate("/masters/discount");
    }
    statusDialogSet(false);
  };

  const [discountName, discountNameSet] = useState(DataItem.discountName);
  const [discountDescription, discountDescriptionSet] = useState(
    DataItem.description
  );

  const defaultType = {
    id: DataItem.discountType,
    name: DataItem.discountTypeName,
  };

  const [selectType, selectedTypeSet] = useState(defaultType);

  const handleDropdown = (e: any) => {
    selectedTypeSet(e);
    reset();
  };

  const reset = () => {
    if (allDiscountData !== undefined) {
      if (allDiscountData.length !== 0) {
        setAllDiscountData((prevSpaces: any) =>
          prevSpaces.map((space: Space) => {
            return {
              ...space,
              durationDetails: space.durationDetails.map(
                (detail: DurationDetail) => {
                  return {
                    ...detail,
                    discountValue: 0,
                    discountPrice: 0,
                  };
                  // return detail;
                }
              ),
            };
          })
        );
      }
    }
  };

  //Sri Code ^
  const [nameError, nameErrorSet] = useState("");
  const [descriptionError, descriptionErrorSet] = useState("");
  const [typeError, typeErrorSet] = useState("");
  const [startError, startErrorSet] = useState("");
  const [endError, endErrorSet] = useState("");
  const [limitError, limitErrorSet] = useState("");
  const [spaceError, spaceErrorSet] = useState("");
  const [check, checkSet] = useState(false);
  const [selectedSpaceTypes, selectedSpaceTypesSet] = useState("");

  useEffect(() => {
    if (check) {
      if (discountName.trim() === "") {
        nameErrorSet("Discount name must be provided");
      } else {
        nameErrorSet("");
      }
      if (discountDescription.trim() === "") {
        descriptionErrorSet("Description must be provided");
      } else {
        descriptionErrorSet("");
      }
      if (selectType.id === null) {
        typeErrorSet("Select the type");
      } else {
        typeErrorSet("");
      }
      if (startDate === undefined) {
        startErrorSet("Choose the Start Date");
      } else {
        startErrorSet("");
      }
      if (endDate === undefined) {
        endErrorSet("Choose the End Date");
      } else {
        endErrorSet("");
      }
      if (selectedUsage === "") {
        limitErrorSet("Enter the Usage limit");
      } else {
        limitErrorSet("");
      }
      if (selectedSpaces.length === 0) {
        spaceErrorSet("Select the Spaces");
        console.log(
          "Error handling",
          selectedSpaceTypes,
          selectedSpaces.length === 0
        );
      } else {
        spaceErrorSet("");
      }
    }
  }, [
    check,
    discountName,
    discountDescription,
    selectType,
    startDate,
    endDate,
    selectedUsage,
    selectedSpaces,
  ]);

  const [loading, setLoading] = useState(false); // State for loading
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault(); // Prevents arrow key actions
    }
    if (event.key === "." || event.key === "," || event.key === "-") {
      event.preventDefault(); // Prevents decimal input
    }
  };

  const handleCancel = () => {
    navigate(-1);
    window.scrollTo(0, 0);
  };

  const [isChecked, setIsChecked] = useState(DataItem.isInstantDiscount);

  const handleInstentCheckboxChange = (event: any) => {
    setIsChecked(event.value);
    if (event.value === false) {
      selectedUsageSet("1");
    } else {
      selectedUsageSet("1");
    }
  };

  return (
    <div>
      {loading ? (
        <div className="loader">
          <Loader size="large" type={"converging-spinner"} />
        </div>
      ) : (
        <div className="overall-view ">
          <div className="overall-view">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Breadcrumbs breadCrumbData={breadCrumbsData} />
              {edited && (
                <Button
                  className="button-view "
                  onClick={() => editedSet(false)}
                >
                  Edit
                </Button>
              )}
            </div>
            <hr className="hr-border" />
          </div>
          <div className="view-margin">
            <div className="common-margin view-margin">
              <div className="custom-input-containers">
                <div className="custom-input-views">
                  <Label className="common-label-size">
                    Discount Name / Coupon Code{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    className="book-height"
                    maxLength={25}
                    type="text"
                    readOnly={edited}
                    value={discountName}
                    onChange={(e) => discountNameSet(e.value)}
                    placeholder="Enter the discount name / Coupon code"
                  />
                  {nameError && <Error>{nameError}</Error>}
                </div>

                <div style={{ width: "40px" }}> </div>
                <div className="custom-input-views" style={{ width: "80%" }}>
                  <Label className="common-label-size">
                    Description <span style={{ color: "red" }}>*</span>
                  </Label>
                  <TextArea
                    maxLength={500}
                    readOnly={edited}
                    value={discountDescription}
                    onChange={(e) => discountDescriptionSet(e.value)}
                    placeholder="Enter Description"
                  />
                  {descriptionError && <Error>{descriptionError}</Error>}
                </div>
              </div>
              <hr className="hr-border" />
              <div className="custom-input-containers">
                <div className="custom-input-views">
                  <Label>
                    Discount Type <span style={{ color: "red" }}>*</span>
                  </Label>
                  <DropDownList
                    svgIcon={chevronDownIcon}
                    className="book-dropdown-new"
                    disabled
                    data={discountTypeList}
                    textField="name"
                    dataItemKey="id"
                    onChange={(e) => handleDropdown(e.target.value)}
                    value={selectType}
                  />
                  {typeError && <Error>{typeError}</Error>}
                </div>
                <div className="custom-input-views">
                  <Label>
                    Start Date <span style={{ color: "red" }}>*</span>
                  </Label>
                  <style>{customStyles}</style>
                  <div
                    className="no-wheel"
                    ref={timePickerRef}
                    style={{ width: "80%" }}
                  >
                    <MyDatePicker
                      minDate={new Date()}
                      checkInDate={startDate!}
                      isDisableCheck={edited}
                      customFormatter={false}
                      setCheckInDate={(e: any) => {
                        setTimeCalc(e, "start");
                      }}
                    />
                  </div>
                  {startError && <Error>{startError}</Error>}
                </div>
                <div className="custom-input-views">
                  <Label>
                    End Date <span style={{ color: "red" }}>*</span>
                  </Label>
                  <style>{customStyles}</style>
                  <div
                    className="no-wheel"
                    ref={timePickerRef}
                    style={{ width: "80%" }}
                  >
                    <MyDatePicker
                      minDate={startDate !== undefined ? startDate : new Date()}
                      checkInDate={endDate!}
                      isDisableCheck={edited}
                      customFormatter={false}
                      setCheckInDate={(e: any) => {
                        setTimeCalc(e, "end");
                      }}
                    />
                  </div>
                  {endError && <Error>{endError}</Error>}
                </div>
              </div>
              <hr className="hr-border" />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <div style={{ marginRight: "10%", width: "30%" }}>
                  <div>
                    Eligible For <span style={{ color: "red" }}>*</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      width: "100%",
                    }}
                  >
                    <RadioButton
                      name="group1"
                      disabled={edited}
                      value="1"
                      checked={selectedValue === "1"}
                      label="All Users"
                      onChange={() => setSelectedValue("1")}
                      style={{ marginRight: "4px" }}
                    />
                    <RadioButton
                      name="group1"
                      disabled={edited}
                      value="2"
                      checked={selectedValue === "2"}
                      label="New users"
                      onChange={() => setSelectedValue("2")}
                      style={{ marginRight: "4px", marginLeft: "10px" }}
                    />
                    <RadioButton
                      name="group1"
                      disabled={edited}
                      value="3"
                      checked={selectedValue === "3"}
                      label="Existing users"
                      onChange={() => setSelectedValue("3")}
                      style={{ marginRight: "4px", marginLeft: "10px" }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "30%",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Checkbox
                    label="Instant Discount"
                    style={{ marginRight: "6px" }}
                    disabled={edited}
                    checked={isChecked}
                    onChange={handleInstentCheckboxChange}
                  />
                </div>

                <div style={{ width: "30%", marginLeft: "10%" }}>
                  <Label>
                    Usage Limit <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="number"
                    maxLength={5}
                    onKeyDown={handleKeyDown}
                    disabled={isChecked}
                    readOnly={edited}
                    className="book-dropdown-news"
                    value={selectedUsage}
                    onChange={(e) => {
                      console.log("Event ->", e.nativeEvent.inputType, e.value);
                      // console.log("Event Type ->", e.nativeEvent.type);
                      if (e.nativeEvent.inputType !== undefined) {
                        if (e.value.toString().length <= 4) {
                          selectedUsageSet(e.value);
                        }
                        if (parseInt(e.value) <= 0) {
                          limitErrorSet("Enter the Usage Limit");
                        }
                      }
                    }}
                  />
                  {check && limitError && <Error>{limitError}</Error>}
                </div>
              </div>
              <hr className="hr-border" />
              {spaceList.length !== 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  Select Applicable Spaces
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                {spaceList.map((item: any, index: any) => (
                  <Checkbox
                    style={{ borderColor: "black", borderStyle: "solid" }}
                    disabled={edited}
                    key={index}
                    value={item.checked}
                    label={item.SpaceType}
                    onChange={() => handleCheckboxChange(item, index)}
                  />
                ))}
              </div>
              {spaceList.length === 0 && (
                <div style={{ justifyContent: "center", display: "flex" }}>
                  {" "}
                  No Spaces Available for this discount
                </div>
              )}
              {spaceError && <Error>{spaceError}</Error>}
              {error && (
                <Error>
                  Please apply discount for any of the selected space duration
                </Error>
              )}
              {allDiscountData.length === 0 && check && (
                <Error>Please Select any of the Space for update</Error>
              )}
              {allDiscountData !== undefined &&
                allDiscountData.map((item: any, indexes: any) => (
                  <div
                    style={{
                      fontWeight: "bold",
                      border: "2px solid black",
                      padding: "10px",
                    }}
                  >
                    {item.spaceName}
                    <div>
                      <table cellPadding="10">
                        <thead>
                          <tr>
                            <th>Duration</th>
                            <th>Actual Price(₹)</th>
                            <th>
                              {" "}
                              {selectType.id === 2
                                ? " Discount Percentage(%)"
                                : "Discount Value(₹)"}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </th>
                            <th>Discount Price(₹)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.durationDetails.map(
                            (durationItem: any, index: any) => (
                              <tr key={index}>
                                <td
                                  style={{ fontWeight: "normal" }}
                                  width={"250px"}
                                >
                                  {durationItem.durationName}
                                </td>
                                <td>
                                  <Input
                                    style={{ color: "grey", textAlign: "end" }}
                                    type="number"
                                    value={durationItem.actualPrice}
                                    readOnly={true}
                                  />
                                </td>
                                <td>
                                  <Input
                                    readOnly={edited}
                                    style={{ textAlign: "end" }}
                                    type="number"
                                    value={durationItem.discountValue}
                                    valid={
                                      durationItem.discountValue > 0 ||
                                      durationItem.discountPrice <= 0
                                    }
                                    min={0}
                                    max={100}
                                    onChange={(e) => {
                                      if (
                                        e.nativeEvent.inputType !== undefined
                                      ) {
                                        handleDiscountChange(
                                          item.spaceName,
                                          durationItem.durationId,
                                          durationItem,
                                          parseInt(e.value) || 0
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  <Input
                                    style={{ color: "grey", textAlign: "end" }}
                                    type="number"
                                    value={durationItem.discountPrice}
                                    readOnly={true}
                                  />
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}

              <div
                className="center-view"
                style={{
                  paddingBottom: "50px",
                }}
              >
                <div className="form-row-area">
                  <div className="form-group-area"></div>
                </div>
                <div className="button-group">
                  {!edited && allDiscountData.length !== 0 && (
                    <Button className="button-view" onClick={updateDiscount}>
                      UPDATE
                    </Button>
                  )}
                  <Button
                    // type="submit"
                    className="common-button-view"
                    onClick={() => handleCancel()}
                  >
                    CANCEL
                  </Button>
                </div>
              </div>
              {statusDialog && (
                <Dialog>
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                    }}
                  >
                    <h3>{alert}</h3>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: "30px",
                      }}
                    >
                      <Button
                        className="button-view"
                        onClick={() => navigateBack()}
                      >
                        Ok
                      </Button>
                    </div>
                  </div>
                </Dialog>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
